"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
var styles_1 = require("@material-ui/core/styles");
var material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
var styles = function (theme, isMobile) {
    var _a;
    return (0, styles_1.makeStyles)({
        container: material_kit_pro_react_1.container,
        root: __assign(__assign({}, material_kit_pro_react_1.container), { display: 'flex', flexDirection: 'column', marginTop: theme.spacing(2), marginBottom: theme.spacing(3), minHeight: 620 }),
        header: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(2),
            paddingRight: isMobile ? theme.spacing(3) : theme.spacing(0)
        },
        enterTicketButton: (_a = {
                marginTop: theme.spacing(4)
            },
            _a[theme.breakpoints.up('lg')] = {
                marginLeft: 0
            },
            _a[theme.breakpoints.down('lg')] = {
                marginLeft: theme.spacing()
            },
            _a[theme.breakpoints.down('md')] = {
                marginLeft: theme.spacing(2)
            },
            _a),
        eligibleGames: {
            marginTop: theme.spacing(4)
        },
        prizeDescriptionLink: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textDecoration: 'none',
            textTransform: 'uppercase'
        },
        winnersBtn: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        srOnly: {
            position: 'absolute',
            width: '1px',
            height: '1px',
            margin: '-1px',
            padding: 0,
            border: 0,
            clip: 'rect(0, 0, 0, 0)',
            overflow: 'hidden'
        }
    });
};
exports.styles = styles;
//# sourceMappingURL=styles.js.map